import * as userSettings from '../includes/user-settings.js';
import downloadFile from '../includes/download-file.js';
import Form from '../includes/form.js';
import SavedFilters from '../includes/filters.js';
import WatchlistButtons from '../includes/watchlist-buttons.js';
import SymbolForm from '../includes/symbol-form.js';

let section;
let results;
let pagination;
let stylesToggle;
let options = {};
let formObj;
let loadResultsLastCall = 0;

function clickableRowInit() {
	$(".clickable-row").on('click',function() {
		const row = $(this).next();
		const height = `${row.find('.inside').innerHeight()}px`;

		if (row.find('.row-detail').css('height') == '0px') {
			row.find('.row-detail').css('height', height);
		} else {
			row.find('.row-detail').css('height', '0');
		}

		$(this).find(".row-detail-indicator").toggleClass('toggled')
	});
}

function alignStockScoreAndChartViewIcons() {
	if( $(window).width() <= 720 ) {
		$('.stock-score-view-chart-icons-aligned .clickable-row').each(function(){
			const clickableRow = $(this);
			const collapsibleRow = $(this).next();
			let scoreIcon = clickableRow.find('.stock-score');
			let cardActions = collapsibleRow.find('.card-actions');
			cardActions.offset({left : scoreIcon.offset().left});
			cardActions.css('justify-content','normal');
		});
	}
}

function stockScorePopoverInit() {
	let elVisible = null;

	document.addEventListener('mouseover', function({ target }) {
		let el;

		if (target.matches('.stock-score-locked')) {
			el = target;
		}

		if (target.closest('.stock-score-locked')) {
			el = target.closest('.stock-score-locked');
		}

		if (target.closest('.popover')?.previousElementSibling?.matches('.stock-score-locked')) {
			el = target.closest('.popover').previousElementSibling;
		}

		if (elVisible && (!el || el !== elVisible)) {
			const visible = elVisible.dataset.popoverVisible ? !!+elVisible.dataset.popoverVisible : false;

			if (visible === true) {
				elVisible.dataset.popoverVisible = 0;
				$(elVisible).popover('hide');

				elVisible = null;
			}
		}

		if (!el) {
			return;
		}

		elVisible = el;

		const visible = el.dataset.popoverVisible ? !!+el.dataset.popoverVisible : false;

		if (visible === false) {
			el.dataset.popoverVisible = 1;
			$(el).popover('show');
		}
	});

	document.addEventListener('click', function() {
		if (elVisible) {
			elVisible.dataset.popoverVisible = 0;
			$(elVisible).popover('hide');

			elVisible = null;
		}
	});
}

function setTableSort() {
	const [ column, order ] = formObj.get('sort').split(',');
	const header = section[0].querySelector(`.results-sort[data-sort-name="${column}"]`);

	if (!header) {
		return;
	}

	const currentHeader = section[0].querySelector('.sort');

	if (currentHeader !== header) {
		currentHeader.classList.remove('sort', 'sort-asc', 'sort-desc');
	}

	header.classList.add('sort');
	header.classList.toggle('sort-asc', order === 'asc');
	header.classList.toggle('sort-desc', order === 'desc');
}

function loadResults() {
	const data = section.serializeJSON();
	loadResultsLastCall = loadResultsLastCall + 1;
	data.loadResultsCall = loadResultsLastCall;

	results.addClass('results-no-results');
	results.find('.stock-list-form-results-alt-row').button('loading');

	ajax('stockListResults', data, function(res) {
		if( data.loadResultsCall != loadResultsLastCall ) {//only applied the last loadResults call made.
			return;
		}

		results.find('.stock-list-form-results-alt-row').button('reset');
		results.find('tbody').empty();
		pagination.empty();

		if (res.noData === true) {
			results.addClass('results-no-results');

			if (options.onResultsLoad) {
				options.onResultsLoad(section, res);
			}
			return;
		}

		results.removeClass('results-no-results');

		results.find('tbody').html($.parseHTML(res.html[0]));
		pagination.html($.parseHTML(res.html[1]));

		WatchlistButtons.init(results);

		clickableRowInit();
		setTableSort();

		if (options.onResultsLoad) {
			options.onResultsLoad(section, res);
		}
	}, function() {
		results.find('.stock-list-form-results-alt-row').button('error');
	});
}

function exportResults() {
	const data = section.serializeJSON();

	data['export'] = 1;

	ajax('stockListResults', data, function(res) {
		downloadFile(
			res.csv,
			`Stock symbols from Financhill.csv`,
			"text/csv");
	});
}

function checkTableOverflow() {
	const parent = results[0].parentElement;
	const tableWidth = results[0].getBoundingClientRect().width;
	const parentWidth = parent.getBoundingClientRect().width;

	document.getElementById('stock-list-wrapper').classList.toggle('stock-list-scroll-has-overflow', (tableWidth - parentWidth) >= 20);
}

function checkTableScroll(isIntersecting) {
	document.getElementById('stock-list-wrapper').classList.toggle('stock-list-scroll-end', isIntersecting);
}

function toggleScrollControls(newScrollValue = null) {
	const buttons = document.getElementById('stock-list-scroll-controls');
	const back = document.getElementById('stock-list-scroll-back');
	const next = document.getElementById('stock-list-scroll-next');

	const wrapper = document.getElementById('stock-list-wrapper');
	const scroll = wrapper.querySelector('.stock-list-scroll');
	const table = wrapper.querySelector('.results-table');

	const style = section[0].querySelector('[name="style"]').value;

	if (style === 'cards') {
		buttons.classList.add('hidden');
	}

	if (!table) {
		return;
	}

	const headers = Array.from(table.querySelectorAll('thead th'));

	const scrollRect = scroll.getBoundingClientRect();
	const tableRect = table.getBoundingClientRect();

	const scrollValue = newScrollValue !== null ? newScrollValue : scroll.scrollLeft;

	back.disabled = scrollValue === 0;
	next.disabled = Math.ceil(scrollValue + scrollRect.width) >= Math.floor(tableRect.width);

	buttons.classList.toggle(
		'hidden',
		scrollRect.width >= tableRect.width || style === 'cards'
	);
}

function scrollControlHandlers() {
	const back = document.getElementById('stock-list-scroll-back');
	const next = document.getElementById('stock-list-scroll-next');

	const callback = (e, direction) => {
		e.preventDefault();

		const wrapper = document.getElementById('stock-list-wrapper');
		const scroll = wrapper.querySelector('.stock-list-scroll');
		const table = wrapper.querySelector('.results-table');

		if (!table) {
			return;
		}

		const headers = Array.from(table.querySelectorAll('thead th'));

		if (direction === 'back') {
			headers.reverse()
		}

		const offset = scroll.getBoundingClientRect();

		for (const header of headers) {
			const isSticky = $(header).hasClass('sticky');
			if(isSticky) {//disable sticky so header offset/start/end work properly
				$(header).toggleClass('sticky');
			}

			const headerOffset = header.getBoundingClientRect();
			const headerStart = headerOffset.left - offset.left;
			const headerEnd = headerStart + headerOffset.width;

			if(isSticky) {//reenable sticky
				$(header).toggleClass('sticky');
			}

			const newScrollLeft = direction === 'back' ?
				Math.floor(scroll.scrollLeft + headerStart) :
				Math.ceil(headerEnd + scroll.scrollLeft - offset.width);

			// console.log({
			// 	offsetWidth: offset.width,
			// 	headerStart,
			// 	headerEnd,
			// 	scrollLeft: scroll.scrollLeft,
			// 	newScrollLeft,
			// 	name: header.textContent.trim(),
			// 	offset,
			// 	headerOffset,
			// })

			if (direction === 'back') {
				if (headerStart < 0) {
					scroll.scrollTo({
						left: newScrollLeft,
					});

					toggleScrollControls(newScrollLeft);

					return;
				}
			}

			if (direction === 'next') {
				if (headerEnd > offset.width) {
					scroll.scrollTo({
						left: newScrollLeft,
					});

					toggleScrollControls(newScrollLeft);

					return;
				}
			}
		}
	};

	back.addEventListener('click', e => callback(e, 'back'));
	next.addEventListener('click', e => callback(e, 'next'));
}

function handleOptionableAlert() {
	const optionable = section[0].querySelector('[name="optionable"]');
	const countries = section[0].querySelector('[name="countries"]');

	if (!optionable || !countries) {
		return;
	}

	const callback = e => {
		const form = new FormData(section[0]);
		const optionable = formObj.get('optionable');
		const countries = form.getAll('countries').pop();

		const activeCountries = countries.split(',');

		if (optionable === 2 && activeCountries.includes('canada') && activeCountries.includes('us')) {
			popup('US &amp; Canadian stocks displayed but only optionable US stocks appear when "optionable stocks" filter selected');
		}
	}

	countries.addEventListener('change', callback);
	formObj.setCallback('optionable', 'set', () => callback());
}

export {
	loadResults,
};

export default async function(res, target, optionsInput = {}) {
	section = $('.section-stock-list');
	results = $(".stock-list-form-results");
	pagination = $(".stock-list-pagination");
	stylesToggle = $(".stock-list-styles");
	options = { ... optionsInput };

	formObj = Form.init(section);

	formObj.setGlobalCallback('set', noDraw => {
		if (options.onFilter) {
			options.onFilter(section);
		}

		if (noDraw === true) {
			return;
		}

		loadResults();
	});

	formObj.setCallback('amount', 'set', value => {
		userSettings.set('stock_list_amount', value);
	});

	formObj.setCallback('stock_type', 'set', value => {
		const elements = Array.from(section[0].querySelectorAll('.stock-list-not-stocks-only, .stock-list-stocks-only'));

		for (const el of elements) {
			const hidden = (value === 0 && el.matches('.stock-list-not-stocks-only')) || (value !== 0 && !el.matches('.stock-list-not-stocks-only'));

			el.classList.toggle('hidden', hidden);
		}
	});

	if (section.has('.saved-filters').length) {
		SavedFilters.init({
			section,
			form: formObj,
			title: res.filtersKey,
			skip: [ 'style', 'page', 'amount', 'use_advanced', 'countries' ],
			savedSettings: res.savedSettings,
			lastSavedSettings: res.lastSavedSettings,
			callback: () => {
				if (options.onFilter) {
					options.onFilter(section);
				}

				loadResults();
			},
		});
	} else {
		SavedFilters.initFiltersToggle();
	}

	clickableRowInit();

	if( $('section.stock-score-view-chart-icons-aligned').length ) {
		alignStockScoreAndChartViewIcons();
		$(window).on('resize', alignStockScoreAndChartViewIcons);
	}

	// target.on('toggleAdvanced', function(e) {
	// 	loadResults();
	// });

	pagination.on('click', 'li > a', function(e) {
		e.preventDefault();
		const page = $(this).data('page');

		pagination.find('.active').removeClass('active');
		$(this).parent().addClass('active');

		formObj.set('page', page);
	});

	stylesToggle.on('click', '.btn', function(e) {
		e.preventDefault();

		const style = $(this).data('style');

		$(this).siblings().removeClass('active');
		$(this).addClass('active');

		results.removeClass('results-table results-cards').addClass(`results-${style}`);

		userSettings.set('stock_list_style', style);
		formObj.set('style', style);
	});

	results.on('click', '.results-sort', function() {
		const [ currentColumn, currentOrder ] = formObj.get('sort').split(',');
		const column = this.dataset.sortName;
		let order;

		if (currentColumn === column) {
			order = currentOrder === 'asc' ? 'desc' : 'asc';
		} else {
			order = 'desc';
		}

		formObj.set('sort', column + ',' + order);
	});

	if (SymbolForm && options.symbolFormCallback) {
		SymbolForm.setCallback(options.symbolFormCallback);
	}

	WatchlistButtons.init(results);

	document.getElementById('stock-list-export')?.addEventListener('click', e => {
		e.preventDefault();

		exportResults();
	});

	if (document.getElementById('stock-list-scroll-controls')) {
		const resizeObserver = new ResizeObserver(entries => {
			checkTableOverflow();
			toggleScrollControls();
		});

		const scrollIntersectionObserver = new IntersectionObserver(
			entries => checkTableScroll(entries[0].isIntersecting),
			{ threshold: .1 }
		);

		const buttonsIntersectionObserver = new IntersectionObserver(
			entries => toggleScrollControls(),
			{ threshold: 1 }
		);

		resizeObserver.observe(section.find('.stock-list-table')[0]);
		scrollIntersectionObserver.observe(results[0].querySelector('thead tr:first-child > :last-child'));

		const headers = results[0].querySelectorAll('thead tr:first-child > :is(:first-child, :last-child, :nth-child(2), :nth-last-child(2))');

		for (const el of headers) {
			buttonsIntersectionObserver.observe(el);
		}

		scrollControlHandlers();
	}

	handleOptionableAlert();
	stockScorePopoverInit();

	if (options.onResultsLoad) {
		options.onResultsLoad(section);
	}

	return { formObj };
};
